import useBreadcrumb from "../hooks/useBreadcrumb";
import BREADCRUMB_CONFIG, { shouldExcludeRoute } from "./breadcrumbConfig";

export const useBreadcrumbUtils = () => {
  const {
    getBreadcrumbs,
    getPreviousRoute,
    clearBreadcrumbs,
    clearBreadcrumbsForNewSession,
  } = useBreadcrumb();

  return {
    getBreadcrumbs,
    getPreviousRoute,
    clearBreadcrumbs,
    clearBreadcrumbsForNewSession,
    shouldExcludeRoute,
    config: BREADCRUMB_CONFIG,
  };
};

export const clearBreadcrumbsOnLogout = () => {
  try {
    sessionStorage.removeItem(BREADCRUMB_CONFIG.storageKey);
  } catch (error) {
    console.error("Error clearing breadcrumbs on logout:", error);
  }
};

export const getBreadcrumbTrail = () => {
  try {
    const storedBreadcrumbs = sessionStorage.getItem(
      BREADCRUMB_CONFIG.storageKey
    );
    return storedBreadcrumbs ? JSON.parse(storedBreadcrumbs) : [];
  } catch (error) {
    console.error("Error reading breadcrumbs:", error);
    return [];
  }
};

export const addExcludedRoute = (routePath) => {
  if (!BREADCRUMB_CONFIG.excludedRoutes.includes(routePath)) {
    BREADCRUMB_CONFIG.excludedRoutes.push(routePath);
  }
};

export const removeExcludedRoute = (routePath) => {
  const index = BREADCRUMB_CONFIG.excludedRoutes.indexOf(routePath);
  if (index > -1) {
    BREADCRUMB_CONFIG.excludedRoutes.splice(index, 1);
  }
};

export const getExcludedRoutes = () => {
  return [...BREADCRUMB_CONFIG.excludedRoutes];
};
